import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useRescheduleFilters } from "../../../../features/reschedule";
import { getErrorMessage } from "../../../../shared/lib/errors/getErrorMessage";
import Loader from "../../../../shared/ui/feedback/Loader/Loader";
import { RescheduleListItem } from "./RescheduleListItem";

export const RescheduleList: React.FC = () => {
  const { data, error, isLoading, isFetchingNextPage, hasNextPage, fetchNextPage } =
    useRescheduleFilters();

  const items = data?.items ?? [];

  const handleLoadMore = () => {
    if (!hasNextPage || isFetchingNextPage) return;
    void fetchNextPage();
  };

  if (error)
    return (
      <div className="my-2 w-full rounded-md border border-[#E63312] bg-[#FFF3F0] p-3">
        <p className="font-['PT_Sans'] text-[16px] font-bold text-[#E63312]">
          {getErrorMessage(error)}
        </p>
      </div>
    );

  if (isLoading && !items.length)
    return (
      <div className="my-10 flex w-full justify-center">
        <Loader />
      </div>
    );

  if (!items.length)
    return (
      <p className="my-10 w-full text-center font-['PT_Sans'] text-[20px] font-bold text-primary">
        Keine Einträge für die aktuellen Filter.
      </p>
    );

  return (
    <InfiniteScroll
      dataLength={items.length}
      next={handleLoadMore}
      hasMore={Boolean(hasNextPage)}
      loader={
        <div className="my-4 flex w-full justify-center">
          <Loader size="small" />
        </div>
      }
      scrollableTarget="scrollableDiv"
      style={{ overflow: "visible" }}
    >
      <div className="flex w-full flex-col gap-4">
        {items.map((item) => (
          <RescheduleListItem key={item.id} item={item} />
        ))}
      </div>

      {isFetchingNextPage && (
        <div className="my-4 flex w-full justify-center">
          <Loader size="small" />
        </div>
      )}
    </InfiniteScroll>
  );
};
